import { Accordion, Card, HiddenVisually, Text, useViewport, useTheme } from "@bookingcom/bui-react";
import NoSSR from "../../../app/NoSSR";
import React, { ReactNode } from "react";
import { Sidebar } from "../Container";
import { DSATraceabilityPopover } from "../FlightDetailsInner/components/DSATraceability";
import Frame from "../Frame";
import SearchFiltersDesktop from "../SearchFilters/SearchFilters.desktop";
import SearchFiltersSummary from "../SearchFiltersSummary";
import AiSummaryDesktop from "./components/AiSummary.desktop";
import { t, useI18n } from "@bookingcom/lingojs-react";
import { DESKTOP_SIDEBAR_WIDTH } from "../../../constants";
import styles from "./SearchResults.desktop.module.css";
import { trackWithDefaultStage } from "@flights/et-universal";

type Props = {
  children: React.ReactNode;
  banners?: ReactNode;
  showGenAiSummary?: boolean;
};

// Temp fix for carousel increasing width
const attributes = { style: { width: `calc(100% - ${DESKTOP_SIDEBAR_WIDTH}px)` } };

const SearchResultsWrapperDesktop = ({ children, banners, showGenAiSummary = false }: Props) => {
  const i18n = useI18n();
  const { isLarge } = useViewport();
  const theme = useTheme();
  const isResponsiveFixes = !isLarge && !!trackWithDefaultStage("flights_web_cat_responsive_fixes_www", 1);

  return (
    <div className={styles.searchResults} data-testid="searchresults_list">
      <NoSSR>
        <Frame direction="row">
          {!isResponsiveFixes ? (
            <Sidebar fixScrollPadding>
              {showGenAiSummary && <AiSummaryDesktop />}

              <Frame pb={3}>
                <SearchFiltersSummary />
              </Frame>
              <SearchFiltersDesktop />
              <DSATraceabilityPopover />
            </Sidebar>
          ) : null}

          <Frame direction="column" grow={1} pb={4} pl={isResponsiveFixes ? 0 : 6} attributes={attributes}>
            {isResponsiveFixes ? (
              <>
                {showGenAiSummary && <AiSummaryDesktop />}

                <Card attributes={{ style: { marginBottom: theme.units.spacing_6x } }}>
                  <Accordion titleContent={<SearchFiltersSummary isResponsiveFixes />}>
                    <>
                      <SearchFiltersDesktop />
                      <DSATraceabilityPopover />
                    </>
                  </Accordion>
                </Card>
              </>
            ) : null}

            <HiddenVisually>
              <Text tagName="h2">{i18n.trans(t("a11y_flights_sr__results_hidden_heading"))}</Text>
            </HiddenVisually>
            {banners}
            {children}
          </Frame>
        </Frame>
      </NoSSR>
    </div>
  );
};

export default React.memo(SearchResultsWrapperDesktop);
